import React from 'react'
import CKEditor from 'react-ckeditor-component'

const { AdminBlock } = global.rootRequire('components/shares/rxTemplates')
const RxCrud = global.rootRequire('components/shares/rxCrud').default
const RxUpload = global.rootRequire('components/shares/rxUpload').default
const RxToggle = global.rootRequire('components/shares/rxToggle').default

export const renderTableHead = (context, vm) =>
  <tr>
    <th className='rxwidth--100'>Pic</th>
    <th className={context.helpSortClass('name', ['rx-th-width-220'])} onClick={(e) => context.onClickSort(e, 'name')}>Name</th>
    <th className={context.helpSortClass('created_at', ['rxwidth--120'])} onClick={(e) => context.onClickSort(e, 'created_at')}>Created at</th>
    <th className='rxwidth--100'>Action</th>
  </tr>

export const renderTableBody = (context, vm) => global.rxu.array(context.state.data).map(perdata =>
  <tr key={perdata._id}>
    <td><img className='betable__img' alt={perdata.name} src={global.rxu.config.base_api + '/upload/image/' + (perdata.img_landscape || 'ico_app_default.jpg')} /></td>
    <td>{perdata.name}</td>
    <td><small>{global.rxu.date(perdata.created_at)}</small></td>
    {context.renderTableBodyBtns(context, perdata)}
  </tr>)

export const renderComponent = (vm) =>
  <AdminBlock name='Review' desc='Manage review'>
    <div className='rxcol-100'>
      <RxCrud
        renderTableHead={vm.renderTableHead} renderTableBody={vm.renderTableBody} name='review' api='api_review' form={[
          { name: 'Picture', func: (context) => (<RxUpload callback={(e) => context.callbackUpload(e)} images={context.state.editingData.img_landscape} />) },

          { type: 'devide' },
          { name: 'Name', func: (context) => (<input tabIndex='1' type='text' value={context.state.editingData.name} onChange={(e) => context.onBlurData(e, 'name')} className='fullwidth-input' />) },

          { type: 'devide' },
          { name: 'Rating', func: (context) => (<input tabIndex='1' type='text' value={context.state.editingData.rating} onChange={(e) => context.onBlurData(e, 'rating')} className='fullwidth-input' />) },

          { type: 'devide' },
          { type: 'fullinput', name: 'Content', func: (context) => (<CKEditor activeClass='p10' content={context.state.editingData.content} events={{ change: (evt) => { const editingData = context.state.editingData; const newContent = evt.editor.getData(); editingData.content = newContent; context.setState({ editingData: editingData }) } }} />) },
          // [[RX_WEB_DATA_CUSTOM]] //
          // [[RX_WEB_DATA_CUSTOM_END]] //

          { type: 'devide' },
          { name: 'Hot', func: (context) => (<RxToggle value={context.state.editingData.is_hot} onToggle={(newValue) => context.onBlurDataValue(newValue, 'is_hot')} />) },
          { type: 'devide' },
          { name: 'Status', func: (context) => (<RxToggle value={context.state.editingData.is_active} onToggle={(newValue) => context.onBlurDataValue(newValue, 'is_active')} />) }
        ]}
      />
    </div>
  </AdminBlock>
